/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { ProductDisplayPrice } from '@/data/types/Product';
import { extractPartNumberFather } from '@/data/utils/extractPartNumberFather';

export type GA4EcommerceItemInput = {
	partNumber?: string; // SKU hijo
	name?: string;
	brand?: string;
	size?: string; // -> item_variant
	genre?: string; // -> item_category
	family?: string; // -> item_category1
	use?: string; // -> item_category2
	price?: number;
	quantity?: number;
	currency?: string;
	affiliation?: string;
	type?: string;
	productPrice?: ProductDisplayPrice;
	sizes?: string[];
	color?: string;
	priceType?: string;
	ribbons?: string[];
	lowStock?: string; // 'Si' | 'No'; default 'No'
};

export const buildGA4EcommerceItem = (input: GA4EcommerceItemInput) => {
	const {
		partNumber,
		name,
		brand,
		size,
		genre,
		family,
		use,
		price,
		quantity,
		currency,
		affiliation,
		type,
		productPrice,
		sizes,
		color,
		priceType,
		ribbons,
		lowStock,
	} = input;

	const list = productPrice?.list ?? 0;
	const offer = productPrice?.offer ?? 0;
	const sizesList = sizes ?? [];

	return {
		item_id: partNumber,
		item_group_id: extractPartNumberFather(partNumber || ''),
		item_name: name,
		coupon: 'N/A',
		discount: list > offer ? list - offer : 0,
		affiliation,
		item_brand: brand,
		item_category: genre,
		item_category1: family,
		item_category2: use,
		item_variant: size,
		price,
		currency,
		quantity,
		type,
		item_tallas_disponibles: sizesList,
		item_tallas_cantidad: sizesList.length.toString(),
		item_color: color,
		item_tipo_precio: priceType,
		item_ribbons: ribbons ?? [],
		item_pocas_piezas: lowStock ?? 'No',
	};
};
